/* eslint-disable react/prop-types */
import "./styles.css";
import {
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
  Button,
  FormGroup,
  Input,
  Label,
} from "reactstrap";
import { useContext, useEffect, useRef, useState } from "react";
import api from "../../../../services/axiosConfig";
import { Context } from "../../../../hooks/useAuthContext";
import { toast } from "react-toastify";
import ModalCancelNF from "./ModalCancelNF/ModalCancelNF";
import { MdAttachMoney } from "react-icons/md";
import { FaReceipt, FaRobot, FaUpload, FaTrash } from "react-icons/fa"; 
import CardNFAdmin from "./CardNfAdmin/CardNFAdmin";
import { format } from "date-fns";
import Swal from "sweetalert2";

function AccordionNfAdmin({
  title,
  apelido,
  id,
  buscarNotasFiscais,
  selectedDatePeriod,
  nota,
}) {
  const { exibirLogs } = useContext(Context);
  const [open, setOpen] = useState();
  const [statusPagamento, setStatusPagamento] = useState();
  const [isCancelModalOpen, setIsCancelModalOpen] = useState(false);
  const fileInputRef = useRef(null);

  const formatDate = (date) => {
    const formattedDate = format(date, 'dd/MM/yyyy HH:mm');
    return formattedDate
  }

  const toggle = (accordionId) => {
    if (open === accordionId) {
      setOpen();
    } else {
      setOpen(accordionId);
    }
  };

  const toggleCancelModal = () => {
    setIsCancelModalOpen(!isCancelModalOpen);
  };

  const renderStatusTag = (status) => {
    let colorClass = "";
    let text = "";
    switch (status) {
      case "emitida":
        colorClass = "status-success";
        text = (
          <>
            <FaReceipt size={20} /> Emitida {nota.dataEmissao ? `em ${formatDate(nota.dataEmissao)}` : ""}
          </>
        );
        break;
      case "pendente":
        colorClass = "status-warning";
        text = (
          <>
            <FaReceipt size={20} /> Pendente
          </>
        );
        break;
        
      case "cancelado":
        colorClass = "status-danger";
        text = (
          <>
            <FaReceipt size={20} /> Cancelada
          </>
        );
        break;

      case "autoEmitida":
        colorClass = "status-auto";
        text = (
          <>
            <FaRobot size={20} /> Auto-emitida
          </>
        );
        break;

      default:
        return null;
    }
    return <span className={`status-tag ${colorClass}`}>{text}</span>;
  };

  const renderStatusTagPagamento = (status) => {
    let colorClassPayment = "";
    let textPayment = "";
    switch (status) {
      case "pendente":
        colorClassPayment = "status-warning-payment";
        textPayment = (
          <>
            <MdAttachMoney />
            Pagamento Pendente
          </>
        );
        break;
      case "doacao":
        colorClassPayment = "status-donate-payment";
        textPayment = (
          <>
            <MdAttachMoney />
            Doação
          </>
        );
        break;
      case "pago":
        colorClassPayment = "status-success-payment";
        textPayment = (
          <>
            <MdAttachMoney />
            Pago
          </>
        );
        break;
      default:
        return null;
    }
    return (
      <span className={`status-tag-outline ${colorClassPayment}`}>
        {textPayment}
      </span>
    );
  };

  const handlePaymentStatusUpdate = async (id) => {
    try {
      await api.patch(`/nf/atualizar-nota/${id}`, {
        statusPagamento: statusPagamento,
      });
      toast.success("Status do pagamento atualizado");
      await buscarNotasFiscais();
    } catch (error) {
      exibirLogs && console.log(error);
      toast.error("Erro ao atualizar status do pagamento");
      throw new Error(
        "Erro ao atualizar nota fiscal: " + error ||
          "Erro desconhecido ao atualizar nota fiscal:"
      );
    }
  };

  useEffect(() => {
    setStatusPagamento(nota.statusPagamento);
  }, [nota]);

  const nomeApelido = `${title} - ${apelido}`;

  const handleFileSelected = async (event) => {
      const arquivo = event.target.files[0];

      if (!arquivo) {
        return;
      }

      toast.promise(
        async () => {
          const todayDate = new Date();
        
          const { data: notaAtualizada } = await api.patch(`/nf/atualizar-nota/${nota._id}`, {
            status: "emitida",
            dataEmissao: todayDate,
          });

          const formData = new FormData();
          formData.append("file", arquivo);

          await api.patch(`/nf/${notaAtualizada._id}/upload`, formData, {
            headers: { "Content-Type": "multipart/form-data" },
          });

          await buscarNotasFiscais();
        },
        {
          pending: 'Enviando nota fiscal...',
          success: 'Nota fiscal enviada e atualizada com sucesso!',
          error: 'Ocorreu um erro ao enviar a nota.',
        }
      );

      event.target.value = null; 
  };

  const uploadNota = async () => {
    const result = await Swal.fire({
      title: 'Enviar Nota Fiscal',
      text: 'Você deseja subir uma nota e atualizar o status?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Sim, enviar',
      cancelButtonText: 'Não'
    });

    if (result.isConfirmed) {
      fileInputRef.current.click();
    }
  }

  const deleteNota = async () => {
    const result = await Swal.fire({
      title: 'Excluir Nota Fiscal',
      text: 'Tem certeza que deseja excluir esta nota fiscal? Esta ação não pode ser desfeita.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sim, excluir',
      cancelButtonText: 'Cancelar'
    });

    if (result.isConfirmed) {
      toast.promise(
        async () => {
          await api.delete(`/nf/${nota._id}/documento`);
          await buscarNotasFiscais();
        },
        {
          pending: 'Excluindo nota...',
          success: 'Nota fiscal excluída com sucesso!',
          error: 'Ocorreu um erro ao excluir a nota.'
        }
      );
    }
  }

  return (
    <Accordion open={open} toggle={toggle}>
      <input
        type="file"
        ref={fileInputRef}
        onChange={handleFileSelected}
        style={{ display: "none" }}
        accept="application/pdf,image/jpeg,image/jpg,image/png,application/xml"
      />

      <AccordionItem style={{ marginBottom: 10 }}>
        <AccordionHeader targetId={id}>
          <div className="accordionHeader">
            <div>
              {apelido ? <span>{nomeApelido}</span> : <span>{title}</span>}{" "}
              <span style={{ color: "red" }}>({nota.tipoConta})</span>
            </div>
            
            <div style={{ display: 'flex', alignItems: 'center' }}>
              {/* Se o status for 'pendente', mantém o hover para upload */}
              {nota.status === 'pendente' ? (
                <div
                  className="hover-container"
                  onClick={uploadNota}
                >
                  <span className="texto-original">
                    {renderStatusTag(nota.status)}
                  </span>
                  <span className="texto-hover">
                    <FaUpload /> Subir nota
                  </span>
                </div>
              ) : (
                // Para qualquer outro status ('emitida', 'cancelado', etc.), apenas exibe a tag
                <div style={{ marginRight: '10px' }}>
                  {renderStatusTag(nota.status)}
                </div>
              )}

              {/* Tag de status de pagamento (sem alteração) */}
              <span>{renderStatusTagPagamento(nota.statusPagamento)}</span>

              {/* Link para a NFE (sem alteração) */}
              {nota.urlNota && (
                <a
                  href={nota.urlNota}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="linkNF"
                >
                  NFE
                </a>
              )}

              {/* NOVO: Ícone de lixeira que aparece apenas se a nota estiver emitida */}
              {nota.status === 'emitida' && (
                <div 
                  onClick={deleteNota} 
                  style={{ cursor: 'pointer', marginLeft: 10, color: '#dc3545' }}
                  title="Excluir Nota Fiscal"
                >
                  <FaTrash size={22} />
                </div>
              )}
            </div>
          </div>
        </AccordionHeader>
        <AccordionBody accordionId={id}>
          <CardNFAdmin
            key={nota._id}
            isEmiting={false}
            values={nota.values}
            tipoContaNF={nota.tipoConta}
            nfId={nota._id}
            buscarNotasFiscais={buscarNotasFiscais}
            selectedDatePeriod={selectedDatePeriod}
            tipoNota={nota.tipoNota}
            nota={nota}
          />
          <div className="NfRowFooter">
            <div style={{ whiteSpace: 'nowrap', display: 'flex', flexDirection: 'column' }}>
              <div><strong>ID da Nota Fiscal:</strong> <span style={{ color: 'red'}}>{nota._id}</span></div>
              <div><strong>Nota criada em:</strong> <span style={{ color: 'red'}}>{formatDate(nota.createdAt)}</span></div>
            </div>
            
            <div  className="actionsNF">
              <FormGroup className="filterGroup">
              <Label>Status do pagamento</Label>
              <Input
                id="selectStatusPagamento"
                name="select"
                type="select"
                style={{ width: 200 }}
                value={statusPagamento}
                onChange={(e) => setStatusPagamento(e.target.value)}
              >
                <option value="pendente">Pendente</option>
                <option value="pago">Pago</option>
                <option value="doacao">Doação</option>
              </Input>
            </FormGroup>
            <Button
              color="success"
              onClick={() => handlePaymentStatusUpdate(nota._id)}
            >
              Salvar
            </Button>
            {nota.status !== "cancelado" && (
              <Button color="danger" onClick={toggleCancelModal}>
                Cancelar Nota Fiscal
              </Button>
            )}
            </div>
          </div>
        </AccordionBody>
      </AccordionItem>

      <ModalCancelNF
        isOpen={isCancelModalOpen}
        toggle={toggleCancelModal}
        nfId={nota._id}
        onSuccess={buscarNotasFiscais}
      />
    </Accordion>
  );
}

export default AccordionNfAdmin;